module.exports = __webpack_public_path__ + "media/images/shared/google_play-c789593bc945b0efce28e02edf329daa26dd465ecd85e5c704d85cc66bd41f05.png";